import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SidebarItemContainer } from './styles.js';

function SidebarItem({ talentUuid, applicationId, vacancyTitle, companyName, selected }) {
  return (
    <SidebarItemContainer className="sidebar-item">
      <a href={`/interview/${talentUuid}?app_id=${applicationId}&token=${localStorage.getItem('token')}`} className={`interview-link ${selected ? 'selected' : ''}`}>
        <b>{vacancyTitle}</b>
        <br></br>
        <div style={{ fontWeight:'normal' }}>{companyName}</div>
      </a>
    </SidebarItemContainer>
  );
}

SidebarItem.propTypes = {
  talentUuid: PropTypes.string.isRequired,
  applicationId: PropTypes.string.isRequired,
  vacancyTitle: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

SidebarItem.defaultProps = {
  selected: false,
};

export default SidebarItem;
